<kendo-dialog *ngIf="isOpen" [width]="600" (close)="close()">
    <kendo-dialog-titlebar>
        <h3>{{ 'SELECT-METHOD' | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate *ngIf="selectionForm" [formGroup]="selectionForm">
        <!--Preferred Language-->
        <kendo-dropdownlist class="float-right" style="width:140px!important" [data]="languages" [textField]="'text'"
            [valueField]="'value'" formControlName="preferredLanguage" [valuePrimitive]="true" attr.aria-label="{{'LANGUAGES' | translate:patientLabel}}">
        </kendo-dropdownlist>
        <!--Patient-->
        <div *ngIf="(memberSelected?.cellPhoneNumber !== null && memberSelected?.cellPhoneNumber !== '') ||
        memberSelected?.email !== null && memberSelected?.email !== ''">
            <h6 class="row m-2 pt-2 text-uppercase">{{patientLabel.patientLabel}}</h6>
            <div class="row m-2 "
                *ngIf="memberSelected?.cellPhoneNumber !== null && memberSelected?.cellPhoneNumber !== ''">
                <div class="col">
                    <input type="radio" value="patientSMS" name="methodRequest" formControlName="methodRequest"
                        id="patientMethodSMS" kendoRadioButton />
                    <label class="k-radio-label" for="patientMethodSMS"><i class="fal fa-mobile"
                            style="width: 30px;text-align: center;"></i>{{memberSelected.cellPhoneNumber | phone}}
                    </label>
                </div>
            </div>
            <div class="row m-2" *ngIf="memberSelected?.email !== null && memberSelected?.email !== ''">
                <div class="col">
                    <input type="radio" value="patientEmail" name="methodRequest" formControlName="methodRequest"
                        id="patientMethodEmail" kendoRadioButton />
                    <label class="k-radio-label" for="patientMethodEmail"><i class="fal fa-envelope"
                            style="width: 30px;text-align: center;"></i>{{memberSelected?.email}}
                    </label>
                </div>
            </div>
        </div>
        @if(type === 'CONSENT') 
        { 
            <!--Log in user-->
            <div *ngIf="loggedInUser && ((loggedInUser?.phoneNumber !== null && loggedInUser?.phoneNumber !== '') ||
                                        (loggedInUser?.email !== null && loggedInUser?.email !== ''))">
                <h6 class="row m-2 pt-2 text-uppercase">{{loggedInUserRoleText}}</h6>
                <div class="row m-2" *ngIf="loggedInUser?.phoneNumber !== null && loggedInUser?.phoneNumber !== ''">
                    <div class="col">
                        <input type="radio" value="loggedInUserSMS" name="methodRequest" formControlName="methodRequest"
                            id="userMethodSMS" kendoRadioButton />
                        <label class="k-radio-label" for="userMethodSMS"><i class="fal fa-mobile"
                                style="width: 30px;text-align: center;"></i>{{loggedInUser?.phoneNumber | phone}}
                        </label>
                    </div>
                </div>
                <div class="row m-2" *ngIf="loggedInUser?.email !== null && loggedInUser?.email !== ''">
                    <div class="col">
                        <input type="radio" value="loggedInUserEmail" name="methodRequest" formControlName="methodRequest"
                            id="userMethodEmail" kendoRadioButton />
                        <label class="k-radio-label" for="userMethodEmail"><i class="fal fa-envelope"
                                style="width: 30px;text-align: center;"></i>{{loggedInUser?.email}}
                        </label>
                    </div>
                </div>
            </div>
            <!--Other-->
            <h6 class="row m-2 pt-2 text-uppercase">{{'OTHER-METHOD' | translate}}</h6>
            <div class="row m-2">
                <div class="col-3">
                    <div class="mt-2">
                        <input type="radio" value="otherSMS" name="methodRequest" formControlName="methodRequest"
                            id="otherMethodSMS" kendoRadioButton
                            attr.aria-label="{{'OTHER-METHOD' | translate}}: {{'SMS' | translate}}" />
                        <label class="k-radio-label" for="otherMethodSMS"><i class="fal fa-mobile"
                                style="width: 30px;text-align: center;"></i>
                        </label>
                    </div>
                </div>
                <label class="col-9 pl-0 pr-0">
                    <div hidden>{{'OTHER-METHOD' | translate}}: {{'PHONE' | translate}}</div>
                    <kendo-maskedtextbox [mask]="phoneNumberMask" id="otherPhone" formControlName="otherPhone"
                        class="w-50" attr.aria-label="{{'OTHER-METHOD' | translate}}: {{'PHONE' | translate}}">
                    </kendo-maskedtextbox>
                    <div>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                            *ngIf="otherPhone.hasError('required') && otherPhone.touched">
                            {{'REQUIRED-PHONE' | translate}}
                        </div>
                    </div>
                </label>
            </div>
            <div class="row m-2">
                <div class="col-3">
                    <div class="mt-2">
                        <input type="radio" value="otherEmail" name="methodRequest" formControlName="methodRequest"
                            id="otherMethodEmail" kendoRadioButton
                            attr.aria-label="{{'OTHER-METHOD' | translate}}: {{'EMAIL' | translate}}" />
                        <label class="k-radio-label" for="otherMethodEmail"><i class="fal fa-envelope"
                                style="width: 30px;text-align: center;"></i>
                        </label>
                    </div>
                </div>
                <div class="col-9 pl-0 pr-0">
                    <input id="otherEmail" attr.aria-label="{{'OTHER-METHOD' | translate}}: {{'EMAIL' | translate}}"
                        kendoTextBox email maxlength="255" formControlName="otherEmail" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="otherEmail.hasError('required') && otherEmail.touched">
                        {{'REQUIRED-EMAIL' | translate}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="otherEmail.invalid && otherEmail.touched && otherEmail.value">
                        {{'WRONG-EMAIL-FORMAT' | translate}}
                    </div>
                </div>
            </div>
        }
    </form>
    <kendo-dialog-actions>
        <button class="k-button" (click)="close()">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick preventTime="5000" [disabled]="!selectionForm?.valid || !selectionForm?.dirty || sending"
            class="k-button k-primary" (click)="send($event)">{{ 'SEND' | translate }}<i class="fal fa-paper-plane"></i>
        </button>
    </kendo-dialog-actions>
</kendo-dialog>